import 'css-chunksrc/client/scenes/workloads/styles.scss';export default {
  "gantt": "_gantt_1w1i0_1",
  "section": "_section_1w1i0_27",
  "layer": "_layer_1w1i0_32",
  "leftPanel": "_leftPanel_1w1i0_40",
  "row": "_row_1w1i0_50",
  "openedDetails": "_openedDetails_1w1i0_64",
  "wbs": "_wbs_1w1i0_68",
  "graph": "_graph_1w1i0_74",
  "grid": "_grid_1w1i0_84",
  "workloads": "_workloads_1w1i0_93",
  "cell": "_cell_1w1i0_97",
  "track": "_track_1w1i0_102",
  "thumb": "_thumb_1w1i0_114",
  "thumbIcon": "_thumbIcon_1w1i0_128",
  "zoomMenu": "_zoomMenu_1w1i0_134",
  "unselectable": "_unselectable_1w1i0_149",
  "exportButton": "_exportButton_1w1i0_153"
};